import styled from '@emotion/styled';
import { colors } from 'crono-fe-common/theme';

export const InformationTaskCardWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 4px;
  gap: 8px;
  padding: 4px 6px;

  &.error {
    background-color: ${colors.inactiveLight};
  }

  &.warning {
    background-color: ${colors.warningOrangeLight};
  }
`;
